export const environment = {
  production: false,
  apiURL: 'https://healthy-staging.med.stanford.edu',
  cdnBaseUrl: 'https://storage.googleapis.com/stg_cdn/'
};
